import {
    Component,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
    EventEmitter,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { UsuarioDTO } from "app/main/apps/shared/interfaces/usuario.interface";
import { NuevoRepresentanteDTO } from "app/main/apps/shared/models/representante.model";
import { fuseAnimations } from "@fuse/animations";
import { SupervisorDTO } from "app/main/apps/shared/interfaces/supervisores.interface";
import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";

@Component({
    selector: "app-tabla-supervisores",
    templateUrl: "./tabla-supervisores.component.html",
    styleUrls: ["./tabla-supervisores.component.scss"],
    animations: fuseAnimations,
})
export class TablaSupervisoresComponent implements OnInit {
    @Input() lista: SupervisorDTO[] = [];
    @Input() superSupervisor: boolean;

    @Output()
    guardarEvent: EventEmitter<NuevoRepresentanteDTO> = new EventEmitter();
    @Output() borrarEvent: EventEmitter<{
        rut: number;
        nombre: string;
    }> = new EventEmitter();

    dataSource: MatTableDataSource<SupervisorDTO> | null;
    displayedColumns = ["rut", "nombres", "apellidos", "email", "acciones"];

    constructor(private _usuarioSrvc: UsuarioService) {}

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource(this.lista);
        this._usuarioSrvc.supervisoresChanged$.subscribe((resp) => {
            this.lista = resp;
            this.dataSource = new MatTableDataSource(this.lista);
        });
    }

    guardar(supervisor: SupervisorDTO) {
        let nuevo = new NuevoRepresentanteDTO(
            parseInt(supervisor.rut.split("-")[0]),
            supervisor.rut.split("-")[1],
            supervisor.nombres,
            supervisor.apellidos,
            supervisor.email
        );
        this.guardarEvent.emit(nuevo);
    }

    borrar(supervisor: SupervisorDTO) {
        const data = {
            rut: parseInt(supervisor.rut.split("-")[0]),
            nombre: `${supervisor.nombres} ${supervisor.apellidos}`,
        };
        this.borrarEvent.emit(data);
    }
}
